import setActiveBuilding from './setActiveBuilding';

export default {
	setActiveBuilding,
};
